import React, { useState } from 'react';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../config/firebase-logging';
function CalculationInput(props) {

    const [output, setOutput] = useState("");
    const [inputValue, setInputValue] = useState("");

    function handleInputChange(event) {
        setInputValue(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        if (isNaN(inputValue) || inputValue === "") {
            alert("Please enter a numerical value");
            return
        }
        if (Math.abs(parseFloat(inputValue) - parseFloat(props.ans)) < 0.2) {
            setOutput(props.successMessage);
            if (props.startConfetti) {
                props.startConfetti();
            }
        } else {
            setOutput(props.failureMessage);
        }
    }

    return (
        <form onSubmit={handleSubmit} style={{justifyContent: "center"}}>
            <div className=' frq row' style={{justifyContent: "center"}}>
                <input placeholder='Enter answer here (no need for units)' onChange={handleInputChange} style={{maxWidth: "300px"}}></input>
                <button className='primary-btn' type='submit'>Enter</button>
            </div>
            {output && <p style={{textAlign: "left", margin: "15px auto 0 auto", width: "fit-content", maxWidth:"700px"}}>{output}</p>}
        </form>
    );
}

export default CalculationInput;